/* eslint-disable no-console */
import openSocket from 'socket.io-client';

function extractBaseUrl(text: string | undefined) {
  const regex = /(https?:\/\/[^/]+)/;
  const match = text?.match(regex);
  return match ? match[0] : null;
}

const socketClient = () => {
  const baseUrl = extractBaseUrl(process.env.NEXT_PUBLIC_SOCKET_PATH);
  const pathUrl = process.env.NEXT_PUBLIC_SOCKET_PATH?.replace(baseUrl || '', '');

  const socket = openSocket(baseUrl || '/', {
    path: pathUrl,
    reconnection: true,
    reconnectionDelay: 3000,
    reconnectionDelayMax: 7000,
    reconnectionAttempts: Infinity,
    autoConnect: true,
    timeout: 10000,
    // @ts-ignore
    jsonp: false,
    transports: ['pooling', 'websocket'],
  });

  socket.on('connect', () => {
    console.log('[SOCKET] connected');
  });

  socket.on('disconnect', () => {
    console.log('[SOCKET] disconnect');
  });

  socket.on('reconnect', () => {
    console.log('[SOCKET] reconnect');
  });

  socket.on('error', (err) => {
    console.log('[SOCKET] received socket error', err);
  });

  socket.on('connect_error', (err) => {
    console.log('[SOCKET] received socket connect error', err);
  });

  socket.open();

  const emit = (event: any, message: any) => {
    console.log(`[SOCKET] emit to "${event}" with message ${message}`);
    socket.emit(event, message);
  };

  const registerHandler = (event: string, handler: any) => {
    console.log('[SOCKET] registerHandler >', event.replace(/_/g, ' '));
    socket.on(event, handler);
  };

  const deregisterHandler = (event: string, handler: any) => {
    console.log('[SOCKET] deregisterHandler >', event.replace(/_/g, ' '));
    if (!handler) {
      socket.off(event);
    } else {
      socket.off(event, handler);
    }
  };

  const connect = () => {
    socket.connect();
  };

  const disconnect = (callback: () => void) => {
    socket.disconnect();
    if (callback) callback();
  };

  return {
    emit,
    registerHandler,
    deregisterHandler,
    connect,
    disconnect,
  };
};
export default socketClient;
